/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STPersonNotificationsApi {
  async Config() : Promise<st.PersonNotificationConfig> {
    return await componentApi.call('st', 'st-person-notifications', 'STPersonNotificationsApi', 'Config', {
    });
  }
  async FetchNotifications(primaryObjectGU : string, identity : string) : Promise<Array<st.PersonNotification>> {
    return await componentApi.call('st', 'st-person-notifications', 'STPersonNotificationsApi', 'FetchNotifications', {
      primaryObjectGU,
      identity,
    });
  }
  async GetNotificationConfiguration() : Promise<Array<st.NotificationInfo>> {
    return await componentApi.call('st', 'st-person-notifications', 'STPersonNotificationsApi', 'GetNotificationConfiguration', {
    });
  }
}
export default new STPersonNotificationsApi()
